import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { loadJsonFile } from './app/utils/load-json-file';
import { IEnvironment } from './environments/environment.type';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import * as Sentry from "@sentry/angular";
function loadBootstrapMain(): void {
  loadJsonFile<IEnvironment>(location.origin + environment.configFile)
    .then((res) => {
      const config = res && res.parsedBody!;
      for (const [key, value] of Object.entries(config)) {
        environment[key] = value;
      }

      if (environment.production) {
        enableProdMode();
      }

      Sentry.init({
        dsn: environment.sentryDsn,
        sendDefaultPii: true,
        enableLogs: true, // - позволяет использовать Sentry.Logger в коде для отправки дополнительных логов
        //Integrations позволяет подключать разные расширения функционала для Sentry как для dev, так и для production-а
        //Sentry.browserTracingIntegration - трассировка и сбор данных о производительности разных страниц приложения
        //Sentry.consoleLoggingIntegration - сбор логов console и отправка на Sentry как логов, необходимо указать уровень отправляемых логов через запятую
        //Sentry.captureConsoleIntegration - захват логов и отправка их как ошибки/хлебные крошки на Sentry
        //Sentry.replayIntegration - создание записи действий пользователя, чтобы воссоздать действия, которые привели к ошибке или долгой загрузки страницы
        integrations: [Sentry.browserTracingIntegration(),
          Sentry.consoleLoggingIntegration({ levels: ["error","warn"] }),
          Sentry.captureConsoleIntegration({ levels: ["error"] }),
          Sentry.replayIntegration({maskAllText: false,blockAllMedia:false,networkDetailAllowUrls: ['/api/hasura'],})

        ],
        tracesSampleRate: 1.0, // Шанс сбора данных о производительности, 50% - каждый второй переход по приложению отправляет данные
        replaysSessionSampleRate: 0.5, // Шанс записи повтора действий пользователя
        replaysOnErrorSampleRate: 1.0, // Шанс записи при ошибке
      });

      bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
    })
    .catch((err) => {
      console.error(
        'Ошибка при попытке загрузить конфигурационный файл',
        environment.configFile,
        err
      );
    });
}

loadBootstrapMain();
